"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Banner = _interopRequireDefault(require("./Banner.style"));

var _dec, _class;

let Banner = (_dec = (0, _reactJss.default)(_Banner.default), _dec(_class = class Banner extends _react.PureComponent {
  render() {
    const {
      classes,
      value,
      size,
      visibility,
      className,
      id,
      error
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.banner, classes[size], {
        error: !!error
      }, {
        hidden: visibility === 'hidden'
      }),
      dangerouslySetInnerHTML: {
        __html: _utils.default.bbCodeToHtml(value)
      }
    });
  }

}) || _class);
Banner.defaultProps = {
  visibility: 'visible',
  error: false,
  size: 'small'
};
var _default = Banner;
exports.default = _default;